// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_tR";
export var lbContainerInner = "B_tS";
export var movingForwards = "B_tT";
export var movingForwardsOther = "B_tV";
export var movingBackwards = "B_tW";
export var movingBackwardsOther = "B_tX";
export var lbImage = "B_tY";
export var lbOtherImage = "B_tZ";
export var prevButton = "B_t0";
export var nextButton = "B_t1";
export var closing = "B_t2";
export var appear = "B_t3";